import * as API from '../api';
import {CREATEREQUEST, UPDATEREQUEST, DELETEREQUEST, GETREQUEST} from '../constants/actionTypes';

export const createRequest = (requestInformation) => async(dispatch) => {
    try{
        const {data} = await API.createRequest(requestInformation);
        dispatch({type: CREATEREQUEST, payload: data});
    } catch (error){
        console.log(error.message);
    }
}

export const getRequests = () => async(dispatch) => {
    try{
        const {data} = await API.getRequests();
        dispatch({type: GETREQUEST, payload: data.myrequests});
    } catch (error){
        console.log(error.message);
    }
}


export const updateRequest = (id, requestInfo) => async (dispatch) => {
    try{
        const {data} = await API.updateRequest(id, requestInfo);
        dispatch({type: UPDATEREQUEST, data});      
    } catch (error){
        console.log(error.message);
    }
}


export const deleteRequest = (id) => async(dispatch) => {
    try{
        const data = await API.deleteRequest(id);
        dispatch({type: DELETEREQUEST, id});
    } catch(error){
        console.log(error.message);
    }
}
